import { render, staticRenderFns } from "./QuoteAnnotations.vue?vue&type=template&id=714a9b75"
import script from "./QuoteAnnotations.vue?vue&type=script&lang=js"
export * from "./QuoteAnnotations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('714a9b75')) {
      api.createRecord('714a9b75', component.options)
    } else {
      api.reload('714a9b75', component.options)
    }
    module.hot.accept("./QuoteAnnotations.vue?vue&type=template&id=714a9b75", function () {
      api.rerender('714a9b75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteAnnotations.vue"
export default component.exports